"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionMenuItem = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var tokens_1 = __importDefault(require("@servicetitan/tokens"));
var hooks_1 = require("../../hooks");
var __1 = require("../");
exports.ActionMenuItem = react_1.default.forwardRef(function (_a, ref) {
    var _b = _a.cascading, cascading = _b === void 0 ? false : _b, children = _a.children, className = _a.className, disabled = _a.disabled, iconName = _a.icon, _c = _a.iconColor, iconColor = _c === void 0 ? tokens_1.default.colorNeutral90 : _c, onFocus = _a.onFocus, onBlur = _a.onBlur, props = __rest(_a, ["cascading", "children", "className", "disabled", "icon", "iconColor", "onFocus", "onBlur"]);
    var newRef = react_1.default.useRef(null);
    var itemRef = ref ? ref : newRef;
    var _d = hooks_1.useFocusVisible(itemRef, onBlur, onFocus), isFocusVisible = _d.isFocusVisible, focusFunction = _d.focusFunction, blurFunction = _d.blurFunction;
    var ActionMenuItemClasses = classnames_1.default('ActionMenuItem', className, {
        'ActionMenuItem--disabled': disabled,
        'ActionMenuItem--cascading': cascading,
        'ActionMenuItem--focus-visible': isFocusVisible,
    });
    return (react_1.default.createElement("div", __assign({ className: ActionMenuItemClasses, ref: itemRef, onFocus: focusFunction, onBlur: blurFunction, tabIndex: disabled ? undefined : 0 }, props),
        iconName ? (react_1.default.createElement("span", { className: "ActionMenuItem__icon" },
            react_1.default.createElement(__1.Icon, { name: iconName, color: iconColor }))) : null,
        react_1.default.createElement("span", { className: "ActionMenuItem__content" }, children),
        cascading ? (react_1.default.createElement("span", { className: "ActionMenuItem__icon" },
            react_1.default.createElement(__1.Icon, { name: "chevron_right" }))) : null));
});
//# sourceMappingURL=ActionMenuItem.js.map